import { render, staticRenderFns } from "./DetailTaxPph22.vue?vue&type=template&id=0e0e6aee"
import script from "./DetailTaxPph22.vue?vue&type=script&lang=js"
export * from "./DetailTaxPph22.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports